import "./genesysChatPopup";
import "./helpers";
import "./measurements";
import formToDataLayer from "./formToDataLayer";

formToDataLayer();
